"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M11 16h2v2h-2z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M13 18h-2v-2h2zm2-4H9v6h6zm4-4.7V4h-3v2.6L12 3 2 12h3l7-6.31L19 12h3z"
}, "1")], 'RoofingTwoTone');